import DataAPISerializer from 'rise-ui/serializers/apis/rise-api/data.js';

import { keyForAttribute, keyForRelationship } from 'rise-ui/utils/serializer/map.js';

@keyForAttribute({
  title:       'recordTitle',
  description: 'recordDescription',
  timezone:    'timezoneId',
})
@keyForRelationship({
  items: 'catalogItems',
})
export default class CatalogRecordSerializer extends DataAPISerializer {}
